import { defineMessages } from 'react-intl'

export default defineMessages({
  duration: {
    id: 'account.subscription.duration',
    defaultMessage:
      '{duration, plural, offset:0 one{1 month} other{{duration} months}}',
  },
  didntGoAsPlanned: {
    id: 'UpdatePaymentDetailsPage.didntGoAsPlanned',
    defaultMessage: "Something didn't go as planned",
  },
  cardRefused: {
    id: 'Redeem.pay.cardRefused',
    defaultMessage:
      'The card was refused. Please make sure you got everything right.',
  },
  invalidCardNumber: {
    id: 'Redeem.pay.invalidCardNumber',
    defaultMessage:
      'Please check that the card number has been entered correctly',
  },
  cvcCodeDeclined: {
    id: 'Redeem.pay.cvcCodeDeclined',
    defaultMessage: 'Please check that you have entered the correct CVC',
  },
  alreadyPremium: {
    id: 'general.already_premium',
    defaultMessage: 'This account already has Lifesum Premium 😀',
  },
  contactCustomerSupport: {
    id: 'Redeem.pay.contactCustomerSupport',
    defaultMessage:
      'If you need any help, please contact support at <a>https://lifesum.com/contact</a>',
  },
  free_trial: {
    id: 'free_trial',
    defaultMessage: 'Free trial',
  },
  UserAccount_Navigation_AccountOverviewLink: {
    id: 'UserAccount_Navigation_AccountOverviewLink',
    defaultMessage: 'Account Overview',
  },
  UserAccount_Navigation_ProfileLink: {
    id: 'UserAccount_Navigation_ProfileLink',
    defaultMessage: 'Profile',
  },
  UserAccount_Navigation_ChangePasswordLink: {
    id: 'UserAccount_Navigation_ChangePasswordLink',
    defaultMessage: 'Change Password',
  },
  UserAccount_Navigation_ManageSubscriptionLink: {
    id: 'UserAccount_Navigation_ManageSubscriptionLink',
    defaultMessage: 'Manage Subscription',
  },

  UserAccount_ChangePassword_MainHeading: {
    id: 'UserAccount_ChangePassword_MainHeading',
    defaultMessage: 'Change Password',
  },
  UserAccount_ChangePassword_CurrentPasswordLabel: {
    id: 'UserAccount_ChangePassword_CurrentPasswordLabel',
    defaultMessage: 'Current password',
  },
  UserAccount_ChangePassword_TogglePasswordButton_Show: {
    id: 'UserAccount_ChangePassword_TogglePasswordButton_Show',
    defaultMessage: 'Show password',
  },
  UserAccount_ChangePassword_TogglePasswordButton_Hide: {
    id: 'UserAccount_ChangePassword_TogglePasswordButton_Hide',
    defaultMessage: 'Hide password',
  },
  UserAccount_ChangePassword_SubmitButtonText: {
    id: 'UserAccount_ChangePassword_SubmitButtonText',
    defaultMessage: 'Change Password',
  },
  UserAccount_ChangePassword_CancelButtonText: {
    id: 'UserAccount_ChangePassword_CancelButtonText',
    defaultMessage: 'Cancel',
  },
  UserAccount_ChangePassword_NewPasswordLabel: {
    id: 'UserAccount_ChangePassword_NewPasswordLabel',
    defaultMessage: 'New password (min. 8 characters)',
  },
  UserAccount_ChangePassword_Messages_Success: {
    id: 'UserAccount_ChangePassword_Messages_Success',
    defaultMessage: 'Your new password has been saved',
  },
  UserAccount_ChangePassword_Messages_Error: {
    id: 'UserAccount_ChangePassword_Messages_Error',
    defaultMessage:
      'Your new password could not be saved. Please try again or contact customer support.',
  },
  UserAccount_ChangePassword_Messages_WrongPassword: {
    id: 'UserAccount_ChangePassword_Messages_WrongPassword',
    defaultMessage: 'Your current password is not correct',
  },
  UserAccount_ChangePassword_Messages_NewPasswordTooShort: {
    id: 'UserAccount_ChangePassword_Messages_NewPasswordTooShort',
    defaultMessage: 'The new password should be at least 8 characters',
  },

  UserAccount_Dashboard_MainHeading: {
    id: 'UserAccount_Dashboard_MainHeading',
    defaultMessage: 'Hi, {name}!',
  },

  UserAccount_AccountDeleted_MainHeading: {
    id: 'UserAccount_AccountDeleted_MainHeading',
    defaultMessage: 'We’re really sorry to see you go.',
  },
  UserAccount_AccountDeleted_BodyCopy: {
    id: 'UserAccount_AccountDeleted_BodyCopy',
    defaultMessage:
      'Your account has been cancelled and your information deleted. Thanks for giving us a try and remember you can come back anytime.',
  },
  UserAccount_AccountDeleted_HomePageLinkText: {
    id: 'UserAccount_AccountDeleted_HomePageLinkText',
    defaultMessage: 'Go to Lifesum Homepage',
  },

  UserAccount_ManageSubscriptionFree_MainHeading: {
    id: 'UserAccount_ManageSubscriptionFree_MainHeading',
    defaultMessage: 'Manage Subscription',
  },
  UserAccount_ManageSubscriptionFree_CurrentSubscriptionBox_Heading: {
    id: 'UserAccount_ManageSubscriptionFree_CurrentSubscriptionBox_Heading',
    defaultMessage: 'Current Subscription',
  },
  UserAccount_ManageSubscriptionFree_CurrentSubscriptionBox_FreePlanText: {
    id: 'UserAccount_ManageSubscriptionFree_CurrentSubscriptionBox_FreePlanText',
    defaultMessage: 'Lifesum Basic Plan',
  },
  UserAccount_ManageSubscriptionFree_CurrentSubscriptionBox_ViewPlansButtonText:
    {
      id: 'UserAccount_ManageSubscriptionFree_CurrentSubscriptionBox_ViewPlansButtonText',
      defaultMessage: 'View Premium plans',
    },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_BilledThrough: {
    id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_BilledThrough',
    defaultMessage: 'Billed through {store}.',
  },
  UserAccount_ManageSubscriptionFree_PremiumBox_Heading: {
    id: 'UserAccount_ManageSubscriptionFree_PremiumBox_Heading',
    defaultMessage: 'Lifesum Premium',
  },
  UserAccount_ManageSubscriptionFree_PremiumBox_IntroText: {
    id: 'UserAccount_ManageSubscriptionFree_PremiumBox_IntroText',
    defaultMessage:
      'Full access to the tools you need to crush your health goals',
  },
  UserAccount_ManageSubscriptionFree_PremiumBox_ChoosePlanHeading: {
    id: 'UserAccount_ManageSubscriptionFree_PremiumBox_ChoosePlanHeading',
    defaultMessage: 'Choose your plan',
  },
  UserAccount_ManageSubscriptionFree_PremiumBox_ChoosePlanIntro: {
    id: 'UserAccount_ManageSubscriptionFree_PremiumBox_ChoosePlanIntro',
    defaultMessage:
      'Did you know that you’re 4x more likely to reach your weight targets with Lifesum Premium?',
  },

  UserAccount_ManageSubscriptionPremium_MainHeading: {
    id: 'UserAccount_ManageSubscriptionPremium_MainHeading',
    defaultMessage: 'Manage Subscription',
  },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_Heading: {
    id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_Heading',
    defaultMessage: 'Current Subscription',
  },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_AutomaticRenewalText:
    {
      id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_AutomaticRenewalText',
      defaultMessage:
        'Your plan will be renewed automatically on {date} and you’ll be charged {amount}.',
    },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_AutomaticRenewalNoChargeText:
    {
      id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_AutomaticRenewalNoChargeText',
      defaultMessage: 'Your plan will be renewed automatically on {date}.',
    },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_FreeTrialText: {
    id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_FreeTrialText',
    defaultMessage:
      'Your subscription will start automatically on {date} and you’ll be charged {amount}.',
  },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_ExpirationText: {
    id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_ExpirationText',
    defaultMessage: 'Your plan will end on {date}',
  },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_CancelSubscriptionButtonText:
    {
      id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_CancelSubscriptionButtonText',
      defaultMessage: 'Cancel subscription',
    },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_PaddleCustomerPortalButtonText:
    {
      id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_PaddleCustomerPortalButtonText',
      defaultMessage: 'Manage your subscription in Paddle',
    },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_StoreNotice: {
    id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_StoreNotice',
    defaultMessage:
      'You can manage and cancel your subscription in {store}. {link}',
  },
  UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_GuideLinkText: {
    id: 'UserAccount_ManageSubscriptionPremium_CurrentSubscriptionBox_GuideLinkText',
    defaultMessage: 'Read our guide',
  },

  UserAccount_EditProfile_MainHeading: {
    id: 'UserAccount_EditProfile_MainHeading',
    defaultMessage: 'Profile',
  },
  UserAccount_EditProfile_BoxHeading: {
    id: 'UserAccount_EditProfile_BoxHeading',
    defaultMessage: 'Personal Details',
  },
  UserAccount_EditProfile_GenderLabel: {
    id: 'UserAccount_EditProfile_GenderLabel',
    defaultMessage: 'Gender',
  },
  UserAccount_EditProfile_FemaleLabel: {
    id: 'UserAccount_EditProfile_FemaleLabel',
    defaultMessage: 'Female',
  },
  UserAccount_EditProfile_MaleLabel: {
    id: 'UserAccount_EditProfile_MaleLabel',
    defaultMessage: 'Male',
  },
  UserAccount_EditProfile_FirstNameLabel: {
    id: 'UserAccount_EditProfile_FirstNameLabel',
    defaultMessage: 'First name',
  },
  UserAccount_EditProfile_DateOfBirthLabel: {
    id: 'UserAccount_EditProfile_DateOfBirthLabel',
    defaultMessage: 'Date of birth',
  },
  UserAccount_EditProfile_CountryLabel: {
    id: 'UserAccount_EditProfile_CountryLabel',
    defaultMessage: 'Country',
  },
  UserAccount_EditProfile_EmailLabel: {
    id: 'UserAccount_EditProfile_EmailLabel',
    defaultMessage: 'Email',
  },
  UserAccount_EditProfile_DeleteButtonText: {
    id: 'UserAccount_EditProfile_DeleteButtonText',
    defaultMessage: 'Close Account & Delete Data',
  },
  UserAccount_EditProfile_SaveButtonText: {
    id: 'UserAccount_EditProfile_SaveButtonText',
    defaultMessage: 'Save changes',
  },
  UserAccount_EditProfile_CancelButtonText: {
    id: 'UserAccount_EditProfile_CancelButtonText',
    defaultMessage: 'Cancel',
  },
  UserAccount_EditProfile_Messages_Success: {
    id: 'UserAccount_EditProfile_Messages_Success',
    defaultMessage: 'Your personal details have been changed.',
  },
  UserAccount_EditProfile_Messages_FirstnameRequired: {
    id: 'UserAccount_EditProfile_Messages_FirstnameRequired',
    defaultMessage: 'Please enter a first name',
  },

  UserAccount_CancelDialog_Heading: {
    id: 'UserAccount_CancelDialog_Heading',
    defaultMessage: 'Are you sure you want to cancel your subscription?',
  },
  UserAccount_CancelDialog_BodyCopy: {
    id: 'UserAccount_CancelDialog_BodyCopy',
    defaultMessage:
      'Your account will remain Premium until the expiry date of your current subscription. You will then be downgraded to Basic.',
  },
  UserAccount_CancelDialog_AbortButtonText: {
    id: 'UserAccount_CancelDialog_AbortButtonText',
    defaultMessage: 'No',
  },
  UserAccount_CancelDialog_ConfirmButtonText: {
    id: 'UserAccount_CancelDialog_ConfirmButtonText',
    defaultMessage: 'Yes, cancel it',
  },
  UserAccount_CancelDialog_CancelledHeading: {
    id: 'UserAccount_CancelDialog_CancelledHeading',
    defaultMessage: 'We’re sorry to see you leaving',
  },
  UserAccount_CancelDialog_CancelledBodyCopy: {
    id: 'UserAccount_CancelDialog_CancelledBodyCopy',
    defaultMessage: 'Hopefully we’ll meet again someday',
  },
  UserAccount_CancelDialog_AlreadyCancelledHeading: {
    id: 'UserAccount_CancelDialog_AlreadyCancelledHeading',
    defaultMessage: 'Your subscription has already been cancelled',
  },

  UserAccount_CountrySelect_TopCountries: {
    id: 'UserAccount_CountrySelect_TopCountries',
    defaultMessage: 'Top Lifesum countries',
  },
  UserAccount_CountrySelect_AllCountries: {
    id: 'UserAccount_CountrySelect_AllCountries',
    defaultMessage: 'All countries',
  },

  UserAccount_PaymentMethod_Heading: {
    id: 'UserAccount_PaymentMethod_Heading',
    defaultMessage: 'Payment method',
  },
  UserAccount_PaymentMethod_UpdateButtonText: {
    id: 'UserAccount_PaymentMethod_UpdateButtonText',
    defaultMessage: 'Update',
  },

  UserAccount_Plan_Free: {
    id: 'UserAccount_Plan_Free',
    defaultMessage: 'Lifesum Basic',
  },
  UserAccount_Plan_Premium: {
    id: 'UserAccount_Plan_Premium',
    defaultMessage:
      '{length, plural, =1{Lifesum Premium (Monthly subscription)} =3{Lifesum Premium (Quarterly subscription)} =6{Lifesum Premium (6 monthly subscription)} =12{Lifesum Premium (Yearly subscription)} =24{Lifesum Premium (2 yearly subscription)} other{Lifesum Premium}}',
  },

  UserAccount_ProfileBox_Heading: {
    id: 'UserAccount_ProfileBox_Heading',
    defaultMessage: 'Profile',
  },
  UserAccount_ProfileBox_EditButtonText: {
    id: 'UserAccount_ProfileBox_EditButtonText',
    defaultMessage: 'Edit Profile',
  },

  UserAccount_PromoBox_Heading: {
    id: 'UserAccount_PromoBox_Heading',
    defaultMessage: '{discount} Off',
  },
  UserAccount_PromoBox_SubHeading: {
    id: 'UserAccount_PromoBox_SubHeading',
    defaultMessage: 'Your New Premium Subscription',
  },
  UserAccount_PromoBox_RedeemButtonText: {
    id: 'UserAccount_PromoBox_RedeemButtonText',
    defaultMessage: 'Redeem Discount',
  },

  UserAccount_SubscriptionBox_Heading: {
    id: 'UserAccount_SubscriptionBox_Heading',
    defaultMessage: 'Subscription',
  },
  UserAccount_SubscriptionBox_PremiumTeaserCopy: {
    id: 'UserAccount_SubscriptionBox_PremiumTeaserCopy',
    defaultMessage:
      'Did you know that you’re 4x more likely to lose unwanted weight with Lifesum Premium?',
  },

  UserAccount_SubscriptionBox_ManageSubscriptionButtonText: {
    id: 'UserAccount_SubscriptionBox_ManageSubscriptionButtonText',
    defaultMessage: 'Manage Subscription',
  },

  UserAccount_SubscriptionPicker_MostPopular: {
    id: 'UserAccount_SubscriptionPicker_MostPopular',
    defaultMessage: 'Most popular',
  },
  UserAccount_SubscriptionPicker_Save: {
    id: 'UserAccount_SubscriptionPicker_Save',
    defaultMessage: 'Save {amount}!',
  },
  UserAccount_SubscriptionPicker_PerMonth: {
    id: 'UserAccount_SubscriptionPicker_PerMonth',
    defaultMessage: '/month',
  },
  UserAccount_SubscriptionPicker_UpgradeButtonText: {
    id: 'UserAccount_SubscriptionPicker_UpgradeButtonText',
    defaultMessage: 'Upgrade',
  },

  UserAccount_PaymentDetailsDialog_SuccessMessage: {
    id: 'UserAccount_PaymentDetailsDialog_SuccessMessage',
    defaultMessage: 'Payment method successfully updated!',
  },
  UserAccount_PaymentDetailsDialog_UpdateButtonText: {
    id: 'UserAccount_PaymentDetailsDialog_UpdateButtonText',
    defaultMessage: 'Update payment details',
  },
  UserAccount_PaymentDetailsDialog_CancelButtonText: {
    id: 'UserAccount_PaymentDetailsDialog_CancelButtonText',
    defaultMessage: 'Cancel',
  },

  UserAccount_DeleteDialog_Heading: {
    id: 'UserAccount_DeleteDialog_Heading',
    defaultMessage: 'Are you sure you want to permanently delete your account?',
  },
  UserAccount_DeleteDialog_BodyCopy: {
    id: 'UserAccount_DeleteDialog_BodyCopy',
    defaultMessage:
      'If you delete your account you’ll lose all the data you added and any kind of subscription. This action can’t be undone.',
  },
  UserAccount_DeleteDialog_Bullet1: {
    id: 'UserAccount_DeleteDialog_Bullet1',
    defaultMessage: 'You’ll lose all the data you added',
  },
  UserAccount_DeleteDialog_Bullet2: {
    id: 'UserAccount_DeleteDialog_Bullet2',
    defaultMessage: 'You’ll lose your paid subscriptions',
  },
  UserAccount_DeleteDialog_Bullet3: {
    id: 'UserAccount_DeleteDialog_Bullet3',
    defaultMessage: 'You can’t undo this action',
  },
  UserAccount_DeleteDialog_CancelButtonText: {
    id: 'UserAccount_DeleteDialog_CancelButtonText',
    defaultMessage: 'Cancel',
  },
  UserAccount_DeleteDialog_ContinueButtonText: {
    id: 'UserAccount_DeleteDialog_ContinueButtonText',
    defaultMessage: 'Yes, continue',
  },
  UserAccount_DeleteDialog_DeleteButtonText: {
    id: 'UserAccount_DeleteDialog_DeleteButtonText',
    defaultMessage: 'Yes, delete my account',
  },
  subscriptionAppliesInAppNotice: {
    id: 'Redeem.pay.subscriptionAppliesInAppNotice',
    defaultMessage:
      'Premium subscriptions purchased here on the website can be accessed on the app by logging in with the same account and email address used for purchase.',
  },
  UserAccount_DeleteDialog_TryAgainButtonText: {
    id: 'UserAccount_DeleteDialog_TryAgainButtonText',
    defaultMessage: 'Try again',
  },
  CancelDialog_Survey_Heading: {
    id: 'CancelDialog_Survey_Heading',
    defaultMessage:
      'Tell us why you’re deleting your account, so we can make Lifesum better.',
  },
  UserAccount_DeleteAccount_Survey_Continue: {
    defaultMessage: 'Close my account & delete my data',
    id: 'UserAccount_DeleteAccount_Survey_Continue',
  },
  UserAccount_DeleteAccount_Survey_Cancel: {
    defaultMessage: 'I want to keep my account',
    id: 'UserAccount_DeleteAccount_Survey_Cancel',
  },
  UserAccount_DeleteDialog_Survey_Option_ReachedMyGoal: {
    id: 'UserAccount_DeleteDialog_Survey_Option_ReachedMyGoal',
    defaultMessage: 'I have reached my goals',
  },
  UserAccount_DeleteDialog_Survey_Option_StrugglingToReachedMyGoal: {
    id: 'UserAccount_DeleteDialog_Survey_Option_StrugglingToReachedMyGoal',
    defaultMessage: 'I’m struggling to reach my goals',
  },
  UserAccount_DeleteDialog_Survey_Option_NoValueFromPremium: {
    id: 'UserAccount_DeleteDialog_Survey_Option_NoValueFromPremium',
    defaultMessage: 'I’m not getting any value from Premium',
  },
  UserAccount_DeleteDialog_Survey_Option_PrivacyConcern: {
    id: 'UserAccount_DeleteDialog_Survey_Option_PrivacyConcern',
    defaultMessage: 'I have a privacy concern',
  },
  UserAccount_DeleteDialog_Survey_Option_DuplicateAccount: {
    id: 'UserAccount_DeleteDialog_Survey_Option_DuplicateAccount',
    defaultMessage: 'I have a duplicate account',
  },
  UserAccount_DeleteDialog_Survey_Option_Other: {
    id: 'UserAccount_DeleteDialog_Survey_Option_Other',
    defaultMessage: 'Other (specify)',
  },
  UserAccount_DeleteDialog_CancelKeepAccountButtonText: {
    id: 'UserAccount_DeleteDialog_CancelKeepAccountButtonText',
    defaultMessage: 'Cancel, I want to keep my account',
  },
  pay_continue_to_paypal: {
    id: 'pay_continue_to_paypal',
    defaultMessage: 'Continue to PayPal',
  },
  UserAccount_ChangeEmail_main: {
    id: 'UserAccount_ChangeEmail_main',
    defaultMessage: 'Change Email',
  },
  UserAccount_ChangeEmail_label: {
    id: 'UserAccount_ChangeEmail_label',
    defaultMessage: 'New email',
  },
  UserAccount_ChangeEmail_button: {
    id: 'UserAccount_ChangeEmail_button',
    defaultMessage: 'Update email',
  },
  UserAccount_ChangeEmail_success_message: {
    id: 'UserAccount_ChangeEmail_prompt_heading',
    defaultMessage: 'Your email has been changed',
  },
  errorEmailAlreadyConnected: {
    id: 'errorEmailAlreadyConnected',
    defaultMessage:
      'This email address might be entered incorrectly or already registered.',
  },
  errorEmailMalformed: {
    id: 'errorEmailMalformed',
    defaultMessage: 'Are you sure you entered your email address correctly?',
  },
  UserAccount_DeleteAccount_Heading: {
    id: 'UserAccount_DeleteAccount_Heading',
    defaultMessage: '{name}, we’re sorry to see you go',
  },
  UserAccount_DeleteAccount_Body: {
    id: 'UserAccount_DeleteAccount_Body',
    defaultMessage:
      '<p>Closing your account means that you will permanently, delete your data from the Lifesum app.</p><p>If you have a Premium subscription, please make sure it has been canceled, so it will not renew. A subscription is not canceled by closing your Lifesum account.</p>',
  },
  UserAccount_DeleteAccount_CancelSubscriptionInfo: {
    id: 'UserAccount_DeleteAccount_CancelSubscriptionInfo',
    defaultMessage:
      'If you have a Premium subscription, please make sure it has been canceled, so it will not renew. A subscription is not canceled by closing your Lifesum account.',
  },
  UserAccount_DeleteAccount_Continue: {
    defaultMessage: 'Continue',
    id: 'UserAccount_DeleteAccount_Continue',
  },
  UserAccount_ExportData_main: {
    id: 'UserAccount_ExportData_main',
    defaultMessage: 'Export data',
  },
  UserAccount_ExportData_Heading: {
    id: 'UserAccount_ExportData_Heading',
    defaultMessage: 'Export nutrition data',
  },
  UserAccount_ExportData_button: {
    id: 'UserAccount_ExportData_button',
    defaultMessage: 'Download file',
  },
  UserAccount_ExportData_description: {
    id: 'UserAccount_ExportData_description',
    defaultMessage:
      'Get a PDF file with your food, calories and nutrients for the selected interval.',
  },
  UserAccount_ExportData_success_message: {
    id: 'UserAccount_ExportData_success_message',
    defaultMessage: 'File downloaded',
  },
  UserAccount_ExportData_error_message: {
    id: 'UserAccount_ExportData_error_message',
    defaultMessage: "Couldn't download file, please try again",
  },
})
